<template lang="pug">
.subsidy-card(:class="{'no-image': !showImage}")
  .subsidy-price-container
    .subsidy
      .reduce-num(v-if="subsidyPrice")
        span -
        span.num {{ subsidyPrice }}
        span 元
      img.subsidy-pic(v-if="showImage && subsidyPic" :src="subsidyPic")
</template>

<script>
export default {
  name: 'SubsidyCard',
  props: {
    subsidyPrice: {
      type: Number,
      default: 0,
    },
    subsidyPic: {
      type: String,
      default: 'https://m.hellobike.com/4a591938d0.png',
    },
    showImage: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="less" scoped>
.subsidy-card {
  width: 100%;
  margin-bottom: -0.4rem;
  display: flex;
  justify-content: center;

  .subsidy-price-container {
    width: 3.12rem;

    .subsidy {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: -0.16rem;

      .reduce-num {
        position: absolute;
        left: 1.61rem;
        top: 0.28rem;
        display: flex;
        align-items: center;
        font-size: 0.12rem;
        font-weight: 400;
        color: #fd1d37;
        line-height: 0.12rem;
        height: 0.12rem;
        z-index: 1;

        .num {
          font-size: 0.2rem;
          line-height: 0.2rem;
          height: 0.2rem;
          margin: -0.06rem 0.02rem 0;
          font-weight: 700;
        }
      }

      .subsidy-pic {
        width: 3.12rem;
        height: auto;
        display: block;
      }
    }
  }

  // 无图片模式：使用纯色背景
  &.no-image {
    .subsidy {
      background: linear-gradient(to right, #f13e7b, #f4573d);
      border-radius: 0.1rem;
      padding: 0.15rem 0.3rem;
      min-height: 0.5rem;
    }
  }
}
</style>
